import { render, staticRenderFns } from "./EditLink.vue?vue&type=template&id=08b4a7d0&scoped=true&"
import script from "./EditLink.vue?vue&type=script&lang=ts&"
export * from "./EditLink.vue?vue&type=script&lang=ts&"
import style0 from "./EditLink.vue?vue&type=style&index=0&id=08b4a7d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b4a7d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
